<template>
  <div>
    <!-- <nav class="filter">
      filter:
      <router-link :to="{query: {}}">all</router-link> |
      <router-link :to="{query: {filter: 'screenshot'}}">screenshot</router-link>
    </nav> -->
    <section>
      <arena-channel-thumbs :channelSlug="channelSlug" :textFilter="$route.query.filter" />
    </section>
  </div>
</template>

<script>
import ArenaChannelThumbs from '@/components/ArenaChannel--Thumbs'
export default {
  name: 'Images',
  components: { ArenaChannelThumbs },
  props: {
    channelSlug: { type: String, default: 'ests' }
  }
}
</script>

<style scoped>
.filter{
  padding-left:20px;
  padding-right:20px
}
</style>
